import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { CategoryPost } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './CategoriesSection.module.scss';
import ArticleCard from '../ArticlesList/ArticleCard';
import '@splidejs/react-splide/css';

const CategoryPosts = ({
  posts,
  index,
  gridClassName = '',
}: {
  posts: CategoryPost[];
  index: number;
  gridClassName: string;
}) => {
  const postsForGrid = posts.slice(0, 4);
  const direction = index % 2 === 0 ? styles.defaultDir : styles.reversedDir;

  return (
    <>
      <div className={styles.sliderWrapper}>
        <Splide
          hasTrack={false}
          options={{
            arrows: false,
            pagination: false,
            gap: 16,
            type: 'slide',
            start: 0,
            autoWidth: true,
            padding: '24px',
            drag: true,
          }}
        >
          <SplideTrack>
            {posts.map(post => (
              <SplideSlide
                key={post.id}
                className={`splide__slide ${styles.postSlide}`}
              >
                <ArticleCard
                  article={post}
                  vertical
                />
              </SplideSlide>
            ))}
          </SplideTrack>
        </Splide>
      </div>
      <div className={classNames(styles.postsGrid, direction, 'container', gridClassName)}>
        {postsForGrid.map(post => (
          <ArticleCard
            key={post.id}
            article={post}
            vertical
          />
        ))}
      </div>
    </>
  );
};

export default CategoryPosts;
